import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestData } from 'src/app/common/models/request-data.model';
import { ComboModel } from './model/combo.model';

@Injectable({
  providedIn: 'root'
})
export class ComboService {
  private apiUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getComboList(requestData: RequestData): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/combo/get`, requestData);
  }

  getComboById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/combo/get/${id}`);
  }

  saveCombo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/combo/save`, data);
  }

  deleteCombo(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/combo/delete/${id}`);
  }

 downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post(environment.baseUrl + '/combo/export', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }

   getSaleItems(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/sale-item/get', requestData);

  }

   getSaleItemById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/sale-item/get/'+id, '');

  }

   /**
     * 
     * @param reasonsInfo 
     * Calls the update API to insert/update the record
     */
     update(reasonsInfo: ComboModel): Observable<any> { 
      if(reasonsInfo.hasOwnProperty("id")){
        return this.http.post(environment.baseUrl+'/combo/update', reasonsInfo);
      } else{
        return this.http.post(environment.baseUrl+'/combo/add', reasonsInfo);
      }
    }
}